import { render, staticRenderFns } from "./KohlerInfinityUpgrades.vue?vue&type=template&id=2f97c46c&scoped=true&"
import script from "./KohlerInfinityUpgrades.vue?vue&type=script&lang=js&"
export * from "./KohlerInfinityUpgrades.vue?vue&type=script&lang=js&"
import style0 from "./KohlerInfinityUpgrades.vue?vue&type=style&index=0&id=2f97c46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97c46c",
  null
  
)

export default component.exports